module.exports = __webpack_public_path__ + "static/img/beef_market.d7380b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/beef_market.png
// module id = v11j
// module chunks = 51